// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader[data-v-ff4964a0]{display:flex;align-items:center;justify-content:center;height:51px;font-size:1rem}.prerequisite[data-v-ff4964a0]{margin-left:10px;border-radius:50%;background-color:#ebae28}.dropdown[data-v-ff4964a0]{max-height:66px}", ""]);
// Exports
module.exports = exports;
